/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MeasurementUIDTOV0 } from './measurementUIDTOV0';
import { WindowTransmissionDetailsUIDTOV0 } from './windowTransmissionDetailsUIDTOV0';


/**
 * Represents details about one of the windows in the building
 */
export interface SAPWindowUIDTOV0 { 
    windowLocation?: SAPWindowUIDTOV0.WindowLocationEnum;
    windowArea?: MeasurementUIDTOV0;
    glazingType?: SAPWindowUIDTOV0.GlazingTypeEnum;
    windowType?: SAPWindowUIDTOV0.WindowTypeEnum;
    orientation?: SAPWindowUIDTOV0.OrientationEnum;
    windowTransmissionDetails?: WindowTransmissionDetailsUIDTOV0;
    pvcFrame?: boolean;
    glazingGap?: SAPWindowUIDTOV0.GlazingGapEnum;
}
export namespace SAPWindowUIDTOV0 {
    export type WindowLocationEnum = '0' | '1' | '2' | '3' | '4';
    export const WindowLocationEnum = {
        _0: '0' as WindowLocationEnum,
        _1: '1' as WindowLocationEnum,
        _2: '2' as WindowLocationEnum,
        _3: '3' as WindowLocationEnum,
        _4: '4' as WindowLocationEnum
    };
    export type GlazingTypeEnum = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | 'ND';
    export const GlazingTypeEnum = {
        _1: '1' as GlazingTypeEnum,
        _2: '2' as GlazingTypeEnum,
        _3: '3' as GlazingTypeEnum,
        _4: '4' as GlazingTypeEnum,
        _5: '5' as GlazingTypeEnum,
        _6: '6' as GlazingTypeEnum,
        _7: '7' as GlazingTypeEnum,
        _8: '8' as GlazingTypeEnum,
        Nd: 'ND' as GlazingTypeEnum
    };
    export type WindowTypeEnum = '1' | '2';
    export const WindowTypeEnum = {
        _1: '1' as WindowTypeEnum,
        _2: '2' as WindowTypeEnum
    };
    export type OrientationEnum = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';
    export const OrientationEnum = {
        _1: '1' as OrientationEnum,
        _2: '2' as OrientationEnum,
        _3: '3' as OrientationEnum,
        _4: '4' as OrientationEnum,
        _5: '5' as OrientationEnum,
        _6: '6' as OrientationEnum,
        _7: '7' as OrientationEnum,
        _8: '8' as OrientationEnum,
        _9: '9' as OrientationEnum
    };
    export type GlazingGapEnum = '6' | '12' | '16+';
    export const GlazingGapEnum = {
        _6: '6' as GlazingGapEnum,
        _12: '12' as GlazingGapEnum,
        _16: '16+' as GlazingGapEnum
    };
}


